import ga from 'helpers/ga';
import { lvtMetricEvent } from '..';
import { TIME_TO_FIRST_INTERACTION_EVENTS } from './constants';

export const trackTimeToFirstInteraction = (): void => {
  window.addEventListener('DOMContentLoaded', () => {
    const listeners: {
      [key: string]: () => void;
    } = {};
    const loadedTimestamp = Date.now();
    const addFirstTimeInteractionEvent = (interactionType: string): void => {
      const firstInteractionTimestamp = Date.now();
      const timeToInteraction = firstInteractionTimestamp - loadedTimestamp;

      ga.sendEvent(
        ...lvtMetricEvent(
          'time_to_first_interaction',
          {
            firstInteractionTimestamp,
            timeToInteraction,
            interactionType,
          },
          'time_to_first_interaction'
        )
      );

      TIME_TO_FIRST_INTERACTION_EVENTS.forEach((event) => {
        if (listeners[event] && typeof window !== 'undefined') {
          window.removeEventListener(event, listeners[event]);
        }
      });
    };
    TIME_TO_FIRST_INTERACTION_EVENTS.forEach((event) => {
      listeners[event] = () => addFirstTimeInteractionEvent(event);
      if (typeof window !== 'undefined') {
        window.addEventListener(event, listeners[event], { once: true });
      }
    });
  });
};
